import { render } from "./SectionPortfolio.vue?vue&type=template&id=4aa33fc8&scoped=true"
import script from "./SectionPortfolio.vue?vue&type=script&lang=js"
export * from "./SectionPortfolio.vue?vue&type=script&lang=js"

import "./SectionPortfolio.vue?vue&type=style&index=0&id=4aa33fc8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4aa33fc8"

export default script